import Api from '../utilities/api';
import {
  triggerIdA, triggerIdU
} from './apiConfig';
import TriskeleScreens from './TriskeleScreens';

export default class ClientAccess {
    static searchUsers = keyword => Api.post('_ClientList_ListofClients', {
      params: [
        {
          name: 'ScrnId',
          value: TriskeleScreens.dashboard.ScreenId

        },
        {
          name: 'TrggrId',
          value: triggerIdA
        },
        {
          name: 'BuildfireID',
          value: "D"
        },
        {
          name: 'SearchTerm',
          value: keyword
        },
        {
          name: 'isVisible',
          value: 1
        }
      ]
    });

    static changeConnectionStatus = (clientId, status) => Api.post('_ClientList_ChangeCnctnStatus', {
      params: [
        {
          name: 'ScrnId',
          value: TriskeleScreens.dashboard.ScreenId

        },
        {
          name: 'TrggrId',
          value: triggerIdU
        },
        {
          name: 'BuildfireID',
          value: "D"
        },
        {
          name: 'ClientID',
          value: clientId
        },
        {
          name: 'PrcsParmtrName',
          value: 'NA'
        },
        {
          name: 'PrcsParmtrValueOne',
          value: 'NA'
        },
        {
          name: 'PrcsParmtrValueTwo',
          value: 'NA'
        },
        {
          name: 'CnctnStatus',
          value: status
        }
      ]
    })

    static getEmailData = () => Api.post('_ClientList_ClientEmail', {
      params: [
        {
          name: 'ScrnId',
          value: TriskeleScreens.dashboard.ScreenId

        },
        {
          name: 'TrggrId',
          value: triggerIdA
        },
        {
          name: 'BuildfireID',
          value: "D"
        },
        {
          name: 'EmailType',
          value: 'New Client'
        },
        {
          name: 'isVisible',
          value: 1
        }
      ]
    })

    static getHealthkitPullPeriod = () => Api.post('_User_UserDataPull', {
      params: [
        {
          name: 'ScrnId',
          value: TriskeleScreens.dashboard.ScreenId
        },
        {
          name: 'TrggrId',
          value: triggerIdA
        },
        {
          name: 'BuildfireID',
          value: "D"
        },
        {
          name: 'isVisible',
          value: 1
        }
      ]
    })

    static getAdminClientsList = (searchTerm = 'NA') => Api.post('_Admin_ClientsList', {
      params: [
        {
          name: 'ScrnId',
          value: TriskeleScreens.adminClients.ScreenId
        },
        {
          name: 'TrggrId',
          value: triggerIdA
        },
        {
          name: 'BuildfireID',
          value: "D"
        },
        {
          name: 'SearchTerm',
          value: searchTerm || 'NA'
        }
      ]
    })

    static getUserSetup = () => Api.post('_User_ProviderUserSetup', {
      params: [
        {
          name: 'ScrnId',
          value: TriskeleScreens.dashboard.ScreenId
        },
        {
          name: 'TrggrId',
          value: triggerIdA
        },
        {
          name: 'BuildfireID',
          value: "D"
        },
        {
          name: 'isVisible',
          value: 1
        }
      ]
    })
}
